import * as moment from 'moment';
import {
  ANALYTICS_DASHBOARD_CONTENT_ERROR,
  GET_INITIAL_ANALYTICS_DASHBOARD_CONTENT,
  GET_MORE_ANALYTICS_DASHBOARD_CONTENT,
  GET_PERIODIC_ANALYTICS_DASHBOARD_CONTENT,
  SET_INITIAL_ANALYTICS_DASHBOARD_CONTENT,
  SET_MORE_ANALYTICS_DASHBOARD_CONTENT,
  SET_PERIODIC_ANALYTICS_DASHBOARD_CONTENT,
  INITIAL_ANALYTICS_DATA_LOADING,
  INITIAL_ANALYTICS_DATA_ERROR,
  INITIAL_ANALYTICS_DATA_RESPONSE
} from '../../Constants/action-types';

import {
  ANALYTICS_DASHBOARD,
  ANALYTICS_DATA_DAY,
  ANALYTICS_DATA_WEEK,
  ANALYTICS_DATA_MONTH
} from '../../functionality/networking';

// Get Initial(on page load) Content
function getInitialAnalyticsDashboardContent(category, isSplitProfileActivityApi, requestId) {
  return {
    type: GET_INITIAL_ANALYTICS_DASHBOARD_CONTENT,
    category,
    isSplitProfileActivityApi: isSplitProfileActivityApi,
    requestId: requestId
  };
}

// get real time content data
function getNewAnalyticsDashboardContent(category) {
  return {
    type: GET_PERIODIC_ANALYTICS_DASHBOARD_CONTENT,
    category
  };
}

// get more content data
function getMoreAnalyticsDashboardContent(category) {
  return {
    type: GET_MORE_ANALYTICS_DASHBOARD_CONTENT,
    category
  };
}

function analyticsDashboardContentError() {
  return {
    type: ANALYTICS_DASHBOARD_CONTENT_ERROR
  };
}

function setInitialAnalyticsDashboardContent(media, category) {
  return {
    type: SET_INITIAL_ANALYTICS_DASHBOARD_CONTENT,
    media: parseAnalyticsDashboardFeed(media),
    category
  };
}

function setNewAnalyticsDashboardContent(media) {
  return {
    type: SET_PERIODIC_ANALYTICS_DASHBOARD_CONTENT,
    media: parseAnalyticsDashboardFeed(media)
  };
}

function setMoreAnalyticsDashboardContent(media, category) {
  return {
    type: SET_MORE_ANALYTICS_DASHBOARD_CONTENT,
    media: parseAnalyticsDashboardFeed(media),
    category
  };
}

function setInitialAnalyticsDataLoading(value) {
  return {
    type: INITIAL_ANALYTICS_DATA_LOADING,
    value: value
  };
}

function setInitialAnalyticsDataResponse(value, combinedMapData) {
  return {
    type: INITIAL_ANALYTICS_DATA_RESPONSE,
    value: value,
    combinedMapData: combinedMapData
  };
}

function setInitialAnalyticsDataError() {
  return {
    type: INITIAL_ANALYTICS_DATA_ERROR
  };
}

export function parseAnalyticsDashboardFeed(media = {}) {
  return {
    tmxMessagesContact: {
      results: media.TMX_MESSAGES_CONTACT ? parseFeedResponse(media.TMX_MESSAGES_CONTACT) : []
    },
    liveUsers: {
      results: media.LIVE_USERS ? parseFeedResponse(media.LIVE_USERS) : []
    },
    liveMessages: {
      results: media.LIVE_MESSAGES ? parseFeedResponse(media.LIVE_MESSAGES) : []
    },
    signals: {
      results: media.LIVE_SIGNALS ? parseFeedResponse(media.LIVE_SIGNALS) : []
    },
    customAssociatedConversation: {
      results: media.LIVE_REPLIES ? parseFeedResponse(media.LIVE_REPLIES) : []
    }
  };
}

export function parseFeedResponse(data) {
  return data.map((x) => {
    const time = moment
      .utc(x.log_time || x.triggered_at)
      .local()
      .fromNow();
    const timeNumber =
      time.split(' ')[0] === 'an' || time?.split(' ')[0] === 'a' ? '1' : time?.split(' ')[0];
    const timeUnit = time?.split(' ')[1].includes('month')
      ? 'mo'
      : time?.split(' ')[1].includes('few')
      ? 's'
      : time?.split(' ')[1].split('')[0];
    return {
      id: x?.message_id || x?.id,
      mediaId: x?.message_id || x?.id,
      userId: x.user_id,
      type: x.type,
      isLoggedIn: x.is_logged_in,
      lastLogin: x.last_login || x.login_timestamp,
      companyName: x.company_name || 'TMX',
      contactName: x.name || x.contact_name || 'TMX',
      orgPic: x.org_pic,
      email: x.user_email,
      thumbnail: x.thumbnail,
      title: x.title,
      occupation: x.occupation,
      searchTerm: x.search_term,
      action: x.action,
      contactTitle: x.contact_title,
      contactType: x.contact_type,
      contactDetail: x.contact_detail,
      time: `${timeNumber}${timeUnit}`,
      timestamp: x.log_time || x.triggered_at,
      state: x.state,
      description: x.message || x.term,
      uploader: x.company_name || 'TMX',
      verified: x.verified,
      location: x.location,
      profilePic: x.profile_file,
      searchedFields: {
        'First name': x.firstname,
        'Last name': x.lastname,
        'Middle name': x.middlename,
        'Date of birth': x.dob,
        'Age range': x.agerange,
        'Address line 1': x.addressline1,
        'Address line 2': x.addressline2,
        AKAS: x.akas,
        Phone: x.phone
      },
      requestExpert: {
        'Story headline': x.request?.['Story Headline'],
        Title: x.request?.['Title'],
        Description: x.request?.['Description'],
        Purpose: x.request?.Purpose,
        'Show Name': x.request?.['Show Name'],
        'Shooting Preference': x.request?.['Shooting Preference'],
        'Type of expert': x.request?.['Type of expert'],
        'Topics that will be discussed': x.request?.['Topics that will be discussed'],
        Deadline: x.request?.['Deadline'],
        'Additional info (optional)': x.request?.['Additional info (optional)']
      },
      invitedEmails: x.user_email,
      actionType:
        x.type === 'USER_ACTION' && x.action === 'VIEW_MORE'
          ? 'VIEWED MORE'
          : x.type === 'USER_ACTION' && x.action === 'COPY_DESCRIPTION'
          ? 'COPIED'
          : x.type === 'INTERESTED' && x.state === 'PENDING_THUMBS_DOWN'
          ? 'NOT INTERESTED'
          : x.type === 'INTERESTED' &&
            (x.action === 'ACCEPTED' ||
              x.state === 'PENDING_THUMBS_UP' ||
              x.action === 'ACCEPTED_UPLOADED')
          ? 'INTERESTED'
          : x.type,
      deviceType:
        x.device_type === 'mobile' ? 'Mobile' : x.device_type === 'desktop' ? 'Desktop' : '',
      cardType:
        x.category === 'INVITES' || x.category === 'TMX_MESSAGES_GENERAL'
          ? 'Tmx_messages'
          : x.category === 'TMX_MESSAGES_CLEARED'
          ? 'Tmx_messages_cleared'
          : x.category === 'TMX_MESSAGES_EXPERT'
          ? 'Tmx_messages_expert'
          : x.category === 'TMX_MESSAGES_CONTACT'
          ? 'Tmx_messages_contact'
          : x.category?.toLowerCase(),
      requestId: x.request_id,
      profileStatus: x.profile_status,
      profileId: x.view_id || x.profile_id,
      profileCreatorName: x.contact_name,
      replyMessage: x.reply_message,
      replyContactName: x.profile_name,
      replyOrg: x.profile_company_name,
      replyLocation: x.profile_location,
      replyOccupation: x.profile_occupation,
      replyOrgPic: x.profile_file,
      uploadTime: x.upload_time,
      uploaderName: x.uploader_name,
      uploaderCompanyName: x.uploader_company_name,
      uploaderLocation: x.uploader_location,
      subMediaData: 'replies' in x ? parseFeedResponse(x.replies) : null,
      rating: 'rating' in x ? x.rating : null,
      conversationId: x?.conversation_id,
      messageId: x?.message_id,
      role: x?.role,
      totalSearches: x?.total_searches,
      searchUsers: x?.users?.split(',').join(', ')
    };
  });
}

export function fetchMoreAnalyticsDashboardContent(payload) {
  return (dispatch, getState) => {
    const { analyticsDashboardReducer, signInReducer } = getState();
    const {
      tmxMessagesContact,
      liveUsers,
      liveMessages,
      signals,
      customAssociatedConversation,

      loadingMoreTmxMessagesContact,
      loadingMoreLiveUsers,
      loadingMoreLiveMessages,
      loadingMoreSignals,
      loadingMoreCustomAssociatedConversation,

      customAssociatedConversationRequestId
    } = analyticsDashboardReducer;

    const mediaId =
      payload.category === 'TMX_MESSAGES_CONTACT'
        ? tmxMessagesContact.results[tmxMessagesContact.results.length - 1]?.id
        : payload.category === 'LIVE_REPLIES'
        ? customAssociatedConversation.results[customAssociatedConversation.results.length - 1]?.id
        : payload.category === 'LIVE_USERS'
        ? liveUsers.results[liveUsers.results.length - 1]?.id
        : payload.category === 'LIVE_MESSAGES'
        ? liveMessages.results[liveMessages.results.length - 1]?.id
        : payload.category === 'LIVE_SIGNALS'
        ? signals.results[signals.results.length - 1]?.id
        : null;

    // Do not fetch more content when;
    // 1 initial content hasn't been loaded
    // 2 If we're still fetching more content
    // 3 If mediaId is null
    if (
      !signInReducer.loading &&
      mediaId &&
      ((!loadingMoreTmxMessagesContact &&
        tmxMessagesContact.loaded &&
        payload.category === 'TMX_MESSAGES_CONTACT' &&
        !tmxMessagesContact.hasFetchedAll) ||
        (!loadingMoreCustomAssociatedConversation &&
          customAssociatedConversation.loaded &&
          payload.category === 'LIVE_REPLIES' &&
          !customAssociatedConversation.hasFetchedAll) ||
        (!loadingMoreLiveUsers &&
          liveUsers.loaded &&
          payload.category === 'LIVE_USERS' &&
          !liveUsers.hasFetchedAll) ||
        (!loadingMoreLiveMessages &&
          liveMessages.loaded &&
          payload.category === 'LIVE_MESSAGES' &&
          !liveMessages.hasFetchedAll) ||
        (!loadingMoreSignals &&
          signals.loaded &&
          payload.category === 'LIVE_SIGNALS' &&
          !signals.hasFetchedAll))
    ) {
      dispatch(getMoreAnalyticsDashboardContent(payload.category));

      const isEmailPresent = JSON.parse(localStorage.getItem('userData'))?.email;
      const isTokenPresent = JSON.parse(localStorage.getItem('userData'))?.token;

      return fetch(ANALYTICS_DASHBOARD, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...payload,
          id: mediaId,
          email: isEmailPresent,
          token: isTokenPresent,
          user_email: customAssociatedConversationRequestId
        })
      })
        .then((response) => response.json())
        .then((response) => {
          const parsedResponse = response;
          dispatch(setMoreAnalyticsDashboardContent(parsedResponse, payload.category));
        })
        .catch((error) => {
          console.error(error);
          dispatch(analyticsDashboardContentError());
        });
    }
  };
}

export function analyticsDashboard(payload, isSplitProfileActivityApi = false, requestId = null) {
  return (dispatch, getState) => {
    const state = getState();
    if (payload.type === 'INITIAL') {
      dispatch(
        getInitialAnalyticsDashboardContent(payload.category, isSplitProfileActivityApi, requestId)
      );
    }
    if (payload.type === 'SCROLL_UP' || payload.type === 'SCROLL_UP')
      dispatch(getNewAnalyticsDashboardContent(payload.category));

    if (!state.signInReducer.loading) {
      return fetch(ANALYTICS_DASHBOARD, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then((response) => response.json())
        .then((response) => {
          const parsedResponse = response;
          if (parsedResponse.success) {
            if (payload.type === 'INITIAL') {
              dispatch(setInitialAnalyticsDashboardContent(parsedResponse, payload.category));
            }

            if (payload.type === 'SCROLL_UP' || payload.type === 'SCROLL_UP')
              dispatch(setNewAnalyticsDashboardContent(parsedResponse));
          }
        })
        .catch((error) => {
          console.error(error);
          dispatch(analyticsDashboardContentError());
        });
    }
  };
}

export function fetchPeriodicAnalyticsDashboardContent({ category }) {
  return (dispatch, getState) => {
    setInterval(() => {
      const { analyticsDashboardReducer } = getState();
      const {
        loadingInitialLiveUsers,

        loadingMoreTmxMessagesContact,
        loadingMoreLiveUsers,
        loadingMoreLiveMessages,
        loadingMoreSignals,
        loadingMoreCustomAssociatedConversation,

        tmxMessagesContact,
        liveUsers,
        liveMessages,
        signals,
        customAssociatedConversation,

        customAssociatedConversationRequestId
      } = analyticsDashboardReducer;

      const mediaId =
        category === 'TMX_MESSAGES_CONTACT'
          ? tmxMessagesContact.loaded
            ? tmxMessagesContact.results[0]?.id
            : null
          : category === 'LIVE_REPLIES'
          ? customAssociatedConversation.loaded
            ? customAssociatedConversation.results[0]?.id
            : null
          : category === 'LIVE_USERS'
          ? liveUsers.loaded
            ? liveUsers.results[0]?.id
            : null
          : category === 'LIVE_MESSAGES'
          ? liveMessages.loaded
            ? liveMessages.results[0]?.id
            : null
          : category === 'LIVE_SIGNALS'
          ? signals.loaded
            ? signals.results[0]?.id
            : null
          : null;

      // Do not Fetch periodic content when a user is loading initial dashboard content or more content.
      if (
        !loadingInitialLiveUsers &&
        !loadingMoreTmxMessagesContact &&
        !loadingMoreCustomAssociatedConversation &&
        !loadingMoreLiveUsers &&
        !loadingMoreLiveMessages &&
        !loadingMoreSignals
      ) {
        const isEmailPresent = JSON.parse(localStorage.getItem('userData'))?.email;
        const isTokenPresent = JSON.parse(localStorage.getItem('userData'))?.token;
        return dispatch(
          analyticsDashboard({
            category,
            type: 'SCROLL_UP',
            id: mediaId ? mediaId : 0,
            email: isEmailPresent,
            token: isTokenPresent,
            user_email: customAssociatedConversationRequestId
          })
        );
      }
    }, 10000);
  };
}

export function InitialAnalyticsData(payload, type) {
  // return (dispatch) => {
  //   dispatch(setInitialAnalyticsDataLoading(true));
  //   callAjaxWCognito(
  //     ANALYTICS_DATA,
  //     (response) => {
  //       const parsedResponse = JSON.parse(response);
  //       // let alterGeoPlotData = geoPlotData;
  //       if (parsedResponse.success) {
  //         dispatch(setInitialAnalyticsDataResponse(parsedResponse, []));
  //       }
  //     },
  //     () => {
  //       dispatch(setInitialAnalyticsDataError());
  //     },
  //     JSON.stringify(payload)
  //   );
  // };

  return (dispatch) => {
    dispatch(setInitialAnalyticsDataLoading(true));

    const URL =
      type === 'DAY'
        ? ANALYTICS_DATA_DAY
        : type === 'WEEK'
        ? ANALYTICS_DATA_WEEK
        : type === 'MONTH'
        ? ANALYTICS_DATA_MONTH
        : '';

    return fetch(URL, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then((res) => res.json())
      .then((parsedResponse) => {
        if (parsedResponse.is_success) {
          dispatch(setInitialAnalyticsDataResponse(parsedResponse, []));
        }
      })
      .catch(() => dispatch(setInitialAnalyticsDataError()));
  };
}
